/* eslint-disable react/prop-types */
import classNames from 'classnames';
import React from 'react';
import { Form } from 'react-bootstrap';

const LabelRadioButton = ({
  required,
  label,
  labelClass,
  labelProps,
  inputProps,
  errorProps,
  options = [],
  controlId,
  formik,
  size = ''
}) => {
  const isError = formik.touched[controlId] && formik.errors[controlId];
  return (
    <Form.Group className="position-relative" controlId={controlId}>
      <Form.Label
        className={classNames(
          'd-block mb-1 fs-9 ps-1 text-capitalize fw-medium',
          { 'fw-bold': required },
          labelClass
        )}
        {...labelProps}
      >
        {label}
        {required ? '*' : ''}
      </Form.Label>

      {options?.map((option, i) => (
        <Form.Check
          key={`option-${option.value}-${i}`}
          size={size}
          inline
          type="radio"
          id={`${controlId}-${i}`}
          value={option.value}
          label={option.label}
          name={controlId}
          checked={formik.values[controlId] === option.value}
          onChange={formik.handleChange}
          defaultChecked={formik.values[controlId] === option.value}
          {...inputProps}
          isInvalid={isError}
        />
      ))}
      <Form.Control.Feedback type="invalid" {...errorProps}>
        {isError ? formik.errors[controlId] : ''}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export default LabelRadioButton;
